export default {
  notificaciones: [],
  cadencia: [
    {
      text: '4 horas',
      value: 4 * 60 * 60 //en segundos
    },
    {
      text: '8 horas',
      value: 8 * 60 * 60 //en segundos
    },
    {
      text: '12 horas',
      value: 12 * 60 * 60 //en segundos
    },
    {
      text: '1 dia',
      value: 1 * 24 * 60 * 60 //en segundos
    },
    {
      text: '2 dia',
      value: 2 * 24 * 60 * 60 //en segundos
    },
    {
      text: '1 semana',
      value: 7 * 24 * 60 * 60 //en segundos
    },
  ]
}